import apiClient from '../api/api';
import { API_ENDPOINTS } from '../api/api.config';

export interface UploadedFile {
  _id: string;
  is_deleted: boolean;
  name: string;
  key: string;
  url: string;
  file_type: string;
  file_size: number;
  file_pages: number;
  upload_type: string;
  file_path: string | null;
  folder_id: string | null;
  uploaded_by: string;
  document_store_id: string;
  ai_performance_level: string;
  file_processing_type: string;
  overall_processed_status: string;
  visual_processing_status: string;
  rag_processing_status: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  file_content?: string;
  file_summary?: string;
  visual_processing?: {
    start_time: string;
    end_time: string;
    time_taken: number;
    status: string;
  };
  rag_processing?: {
    start_time: string;
    end_time: string;
    time_taken: number;
    status: string;
  };
  overall_processing?: {
    start_time: string;
    end_time: string;
    time_taken: number;
    status: string;
  };
  uploaded_at?: string;
}

export interface UploadedFilesListParams {
  skip: number;
  limit: number;
  document_store_id: string;
  folder_id?: string | null;
}

export interface UploadedFilesListResponse {
  success: boolean;
  code: number;
  data: {
    total_count: number;
    uploadedFilesList: UploadedFile[];
    last_modified: string;
  };
}

export interface GetStatusByIdsParams {
  file_ids: string[];
  document_store_id: string;
}

export interface FileStatusUpdate {
  _id: string;
  overall_processed_status: string;
  visual_processing_status: string;
  rag_processing_status: string;
}

export interface GetStatusByIdsResponse {
  success: boolean;
  code: number;
  data: FileStatusUpdate[];
}

class UploadedFilesService {
  async getUploadedFiles(params: any): Promise<UploadedFilesListResponse> {
    try {
      const response = await apiClient.post(
        '/dms-v2-srv/uploaded-file-srv/utils/list',
        params
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching uploaded files:', error);
      throw error;
    }
  }

  async getUploadedFilesDropdown(params: any): Promise<any> {
    try {
      const response = await apiClient.post(
        '/dms-v2-srv/uploaded-file-srv/utils/dropdown',
        params
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching uploaded files:', error);
      throw error;
    }
  }

  async getStatusByIds(params: any): Promise<GetStatusByIdsResponse> {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.UPLOADED_FILES.GET_STATUS_BY_IDS,
        params
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching file statuses:', error);
      throw error;
    }
  }

  async deleteFile(id: string): Promise<void> {
    try {
      await apiClient.delete(API_ENDPOINTS.UPLOADED_FILES.DELETE(id));
    } catch (error) {
      console.error(`Error deleting file ${id}:`, error);
      throw error;
    }
  }
}

export const uploadedFilesService = new UploadedFilesService();
export default uploadedFilesService;
